import React from 'react';

const SweetsCollectionLayout = ({ children, ...props }) => {
  return (
      <div>
        {
          children
        }
      </div>
  );
};

export default SweetsCollectionLayout;
